import { render, staticRenderFns } from "./repayment-confirmation.vue?vue&type=template&id=22cff87e"
import script from "./repayment-confirmation.vue?vue&type=script&lang=ts"
export * from "./repayment-confirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports